module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-hollandsnieuwe-03@2x.a1fb3b69.jpg";